module.exports = __webpack_public_path__ + "static/img/2areaA_20.473d222.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/2areaA_20.png
// module id = 890
// module chunks = 1